import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Textarea } from "@/components/ui/textarea";
import { KEYS } from "@/lib/tourHelper";
import { AnswerSubCategoryDetail } from "@/schema/app/assessment/answerSubCategoryDetail";
import { useId } from "react";
import { useController, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface QuestionProps {
  index: number;
}

function Question({ index }: QuestionProps) {
  const id = useId();
  const { t } = useTranslation();
  const { control } = useFormContext<AnswerSubCategoryDetail>();

  const {
    field: { value: isSubmitted },
  } = useController({
    control,
    name: `is_submitted`,
  });

  const {
    field: { value: content },
  } = useController({
    control,
    name: `answer_contents.${index}.content`,
  });

  const {
    field: { value: extenstionNote, onChange: onExtensionNoteChange },
  } = useController({
    control,
    name: `answer_contents.${index}.extension_note`,
  });

  const {
    field: { value: answer, onChange: onAnswerChange },
  } = useController({
    control,
    name: `answer_contents.${index}.answer`,
  });

  return (
    <div className="px-5 pb-6 pt-5">
      <div className="font-medium whitespace-pre-wrap">
        {index + 1}. {content}
      </div>
      <RadioGroup
        data-tour={index === 0 ? KEYS.SUB_CATEGORY.MULTIPLE_CHOICE : undefined}
        className="mt-5 inline-flex gap-12"
        value={answer ? answer.toString() : ""}
        onValueChange={(value) => {
          onAnswerChange(parseInt(value));
        }}
        disabled={isSubmitted}
      >
        <label
          htmlFor={`${id} 0`}
          className="cursor-pointer inline-flex items-center gap-2"
        >
          <RadioGroupItem value="1" id={`${id} 0`} />
          <span>{t("yes")}</span>
        </label>
        <label
          htmlFor={`${id} 1`}
          className="cursor-pointer inline-flex items-center gap-2"
        >
          <RadioGroupItem value="2" id={`${id} 1`} />
          <span>{t("no")}</span>
        </label>
        <label
          htmlFor={`${id} 2`}
          className="cursor-pointer inline-flex items-center gap-2"
        >
          <RadioGroupItem value="3" id={`${id} 2`} />
          <span>{t("not-applicable")}</span>
        </label>
      </RadioGroup>
      {isSubmitted ? (
        <div className="whitespace-pre-wrap mt-5 py-2 px-3 bg-gray-100 text-gray-800 border border-gray-300 rounded-md shadow-sm">
          {extenstionNote ? extenstionNote : t("no-supplemental-information")}
        </div>
      ) : (
        <>
          <Textarea
            data-tour={index === 0 ? KEYS.SUB_CATEGORY.TEXTAREA : undefined}
            className="mt-5"
            placeholder="補足説明を記載してください"
            value={extenstionNote ?? ""}
            onChange={(e) => onExtensionNoteChange(e.target.value)}
          />
          <div className="mt-2 text-end text-muted-foreground">
            {extenstionNote ? `${extenstionNote.length} ` : "0 "}
            {t("characters")}
          </div>
        </>
      )}
    </div>
  );
}

export default Question;
